import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Impressum from './pages/Impressum';
import Datenschutz from './pages/Datenschutz';
import OfferLandingPage from './pages/OfferLandingPage';
import AgentLogin from './pages/admin/AgentLogin';
import OfferDashboard from './pages/admin/OfferDashboard';
import OfferForm from './pages/admin/OfferForm';
import { AuthProvider, useAuth } from './context/AuthContext';
import { Toaster } from './components/ui/toaster';
import WhatsAppButton from './components/WhatsAppButton';
import { Navigate } from 'react-router-dom';

// Protected Route component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return <div className="min-h-screen flex items-center justify-center">Laden...</div>;
  }
  
  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace />;
  }
  
  return children;
};

// Layout wrapper that hides header/footer for admin and offer pages
const AppLayout = ({ children }) => {
  const location = useLocation();
  const isAdminPage = location.pathname.startsWith('/admin');
  const isOfferPage = location.pathname.startsWith('/angebot');
  const hideLayout = isAdminPage || isOfferPage;

  return (
    <div className="App">
      {!hideLayout && <Header />}
      <main>
        {children}
      </main>
      {!hideLayout && <Footer />}
      {!hideLayout && <WhatsAppButton />}
      <Toaster />
    </div>
  );
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppLayout>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Home />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
            
            {/* Public Offer Page */}
            <Route path="/angebot/:offerId" element={<OfferLandingPage />} />
            
            {/* Admin Routes */}
            <Route path="/admin/login" element={<AgentLogin />} />
            <Route path="/admin/offers" element={
              <ProtectedRoute>
                <OfferDashboard />
              </ProtectedRoute>
            } />
            <Route path="/admin/offers/new" element={
              <ProtectedRoute>
                <OfferForm />
              </ProtectedRoute>
            } />
            <Route path="/admin/offers/edit/:offerId" element={
              <ProtectedRoute>
                <OfferForm />
              </ProtectedRoute>
            } />
          </Routes>
        </AppLayout>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;